module.exports = __webpack_public_path__ + "img/imagemissing4.36e24eda.jpg";